import { render, staticRenderFns } from "./TeleHealthEducation.vue?vue&type=template&id=5fff7cfa&"
import script from "./TeleHealthEducation.vue?vue&type=script&lang=js&"
export * from "./TeleHealthEducation.vue?vue&type=script&lang=js&"
import style0 from "./TeleHealthEducation.vue?vue&type=style&index=0&id=5fff7cfa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports